import { create } from "zustand";

interface CommandModalState {
  isOpen: boolean;
  /** 열자마자 들을지. 모바일 마이크 진입점으로 열었을 때만 참. */
  autoListen: boolean;
}

interface CommandModalActions {
  open: (options?: { listen?: boolean }) => void;
  close: () => void;
}

type CommandModalStore = CommandModalState & CommandModalActions;

export const useCommandModalStore = create<CommandModalStore>()((set) => ({
  isOpen: false,
  autoListen: false,
  open: (options) => set({ isOpen: true, autoListen: options?.listen ?? false }),
  close: () => set({ isOpen: false, autoListen: false }),
}));

export const selectCommandModalOpen = (state: CommandModalStore) => state.isOpen;
export const selectCommandAutoListen = (state: CommandModalStore) => state.autoListen;
export const selectOpenCommandModal = (state: CommandModalStore) => state.open;
export const selectCloseCommandModal = (state: CommandModalStore) => state.close;

export type { CommandModalState, CommandModalActions, CommandModalStore };
